/**
 * Adjust Vee Validate configuration to avoid conflicts with Element UI library
 * http://vee-validate.logaretm.com/configuration.html#configuration
 */
import Vue from 'vue';
import ValidatorLocale from 'vee-validate/dist/locale/nl';
import VeeValidate, { Validator } from 'vee-validate';

const config = {
    fieldsBagName: 'form-elements',
    events: 'input'
};

Validator.localize('nl', ValidatorLocale);
Vue.use(VeeValidate, config);
